import { render, staticRenderFns } from "./CeisaBarangForm.vue?vue&type=template&id=7cb4576e&"
import script from "./CeisaBarangForm.vue?vue&type=script&lang=js&"
export * from "./CeisaBarangForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports